<template>
  <main>
    <!-- left box -->
    <div class="left-box">
      <div class="login-logo">
        <img src="@/assets/ecs_main_logo.jpg" width="200" alt="">
      </div>
      <div class="wrapper">
        <div class="rec-prism">
          <div class="face face-front">
            <div class="content">
              <h2>Welcome! ✨</h2>
              <h2 style="margin-bottom: 20px;">E-Tube</h2>
              <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <form
                  @submit.prevent="handleSubmit(signin)"
                  @reset.prevent="reset"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <div class="field-wrapper">
                      <input v-model="model.email" type="text" name="email" placeholder="email">
                      <label>Email</label>
                      <span style="color: red; font-size: smaller;"  v-if="errors.length >= 1">{{errors[0]}}</span>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <div class="field-wrapper">
                      <input v-model="model.password" type="password" name="password" placeholder="password" autocomplete="new-password">
                      <label>Password</label>
                      <span style="color: red; font-size: smaller;" v-if="errors.length >= 1">{{errors[0]}}</span>
                    </div>
                  </ValidationProvider>
                  <div class="mt-6 d-flex">
                    <v-btn
                      type="submit"
                      :loading="loading"
                      class="btn-login"
                    >
                      로그인
                    </v-btn>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
          <!-- <div class="face face-bottom">
            <div class="content">
              <div class="thank-you-msg">
                Thank you!
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- right box -->
    <div class="right-box">
      <img class="right-img"
        src="@/assets/login_background.jpg"
        width="760"
        height="1024" 
        alt="Authentication">
      <!-- <img class="center-img"
        src="../../../static/images/auth-decoration.png"
        alt="Authentication decoration"
      /> -->
    </div>
  </main>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    mode: {
      login: true
    },
    error: null,
    loading: false,
    model: {
      username: '',
      email: '',
      password: '',
      passwordAgain: ''
    },
    defaultModel: {
      username: '',
      email: '',
      password: '',
      passwordAgain: ''
    },
    settings: {
      organizations: {
        type: 'local'
      },
      meetings: null,
      webex: {
        useBot: false,
        botKey: ''
      }
    },
    titleImg: '/static/images/login_title.gif',
    isIDSave: false
  }),
  watch: {
  },
  methods: {
    async signin() {
      if (this.loading) return
      this.loading = true

      const data = await this.$store
        .dispatch('signIn', { email: this.model.email, password: this.model.password })
        .catch((err) => {
          this.loading = false
          const reason = err.response.data.error
          if (reason.includes('password')) {
            this.$refs.form.setErrors({
              Password: ["비밀번호가 일치하지 않습니다."]
            })
          } else {
            this.$refs.form.setErrors({
              Email: ["이메일을 찾을 수 없습니다."],
            })
          }
        })

      if (!data) return
      const user = await this.$store
        .dispatch('getCurrentUser', data.token)
        .catch((err) => console.log(err))

      if (!user) return

      this.loading = false
      this.showThankYou();
      setTimeout(() => {
        this.$router.push({ name: 'Home' })
      }, 500);
    },
    showLogin () {
      // front
      let prism = document.querySelector('.rec-prism');
      prism.style.transform = 'translateZ(-100px) rotateY( -90deg)';
    },
    showZoomLogin () {
      // right
      let prism = document.querySelector('.rec-prism');
      prism.style.transform = 'translateZ(-100px)';
    },
    showForgotPassword () {
      let prism = document.querySelector('.rec-prism');
      prism.style.transform = 'translateZ(-100px) rotateY( -180deg)';
    },
    showTop () {
      // top
      let prism = document.querySelector('.rec-prism');
      prism.style.transform = 'translateZ(-100px) rotateX( -90deg)';
    },
    showContactUs () {
      let prism = document.querySelector('.rec-prism');
      prism.style.transform = 'translateZ(-100px) rotateY( 90deg)';
    },
    showThankYou () {
      let prism = document.querySelector('.rec-prism');
      prism.style.transform = 'translateZ(-100px) rotateX( 90deg)';
      this.signin();
    },
    
    goPage (page) {
      this.$router.replace('/' + page);
    },
  },
};
</script>
<style scoped lang="css">
* {
  /* box-sizing: border-box; */
}

@media (max-width: 768px) {
  .wrapper {
    width: 90% !important;
  }
  .left-box {
    width: 100% !important;
    /* background-image: url("../../assets/login_background.jpg") */
  }
  .right-box {
    display: none;
  }
  .face {
    border: 2px solid #546FFE !important;
  }
}

main {
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14px;
  background: #f6fffd;
  height: 100%;
  width: 100%;
}

.left-box {
  width: 50%;
  height: 100%;
  float: left;
  display: flex;
  align-items: center;
  background: #ffff !important;
}

.left-box > .login-logo {
  position: fixed;
  top: 0;
  left: 0;
  width: auto;
  height: 90px;
  margin: 0;
  padding: 25px 0 0 25px;
  z-index: 11;
}

.right-box {
  width: 50%;
  height: 100%;
  float: right;
  position: relative;
}

.right-box > .right-img {
  position: absolute; top:0; left: 0;
  width: 100%;
  height: 100%;
}

.right-box > .center-img {
  position: absolute;
  top: 45%;
  left: -8%;
  width: 20%;
}

.wrapper {
  display: flex;
  width: 35vw;
  height: 50vh;
  margin: 60px auto;
  perspective: 600px;
  /* text-align: center; */
  align-items: center;
}

.rec-prism {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transform: translateZ(-100px);
  transition: transform 0.5s ease-in;
}

.face {
  position: absolute;
  width: 100%;
  padding: 20px;
  border: 0px solid #546FFE;
  border-radius: 3px;
}
.face .content {
  color: #666;
  text-align: left;
}
.face .content h2 {
  font-size: 4vh;
  color: #546FFE;
  margin-bottom: 5px;
  height: 100%;
}

.face .content .field-wrapper {
  margin-top: 30px;
  position: relative;
}
.face .content .field-wrapper label {
  position: absolute;
  pointer-events: none;
  font-size: 1.35em;
  top: 20%;
  left: 0;
  transition: all ease-in 0.25s;
  color: #999999;
}
.face .content .field-wrapper input[type=text], .face .content .field-wrapper input[type=password], .face .content .field-wrapper input[type=submit], .face .content .field-wrapper textarea {
  -webkit-appearance: none;
  appearance: none;
}
.face .content .field-wrapper input[type=text]:focus, .face .content .field-wrapper input[type=password]:focus, .face .content .field-wrapper input[type=submit]:focus, .face .content .field-wrapper textarea:focus {
  outline: none;
  color: gray;
}
.face .content .field-wrapper input[type=text], .face .content .field-wrapper input[type=password], .face .content .field-wrapper textarea {
  width: 100%;
  border: none;
  background: transparent;
  line-height: 2em;
  border-bottom: 1px solid #546FFE;
  color: #666;
  font-size: 1.5rem;
}
.face .content .field-wrapper input[type=text]::-webkit-input-placeholder, .face .content .field-wrapper input[type=password]::-webkit-input-placeholder, .face .content .field-wrapper textarea::-webkit-input-placeholder {
  opacity: 0;
}
.face .content .field-wrapper input[type=text]::-moz-placeholder, .face .content .field-wrapper input[type=password]::-moz-placeholder, .face .content .field-wrapper textarea::-moz-placeholder {
  opacity: 0;
}
.face .content .field-wrapper input[type=text]:-ms-input-placeholder, .face .content .field-wrapper input[type=password]:-ms-input-placeholder, .face .content .field-wrapper textarea:-ms-input-placeholder {
  opacity: 0;
}
.face .content .field-wrapper input[type=text]:-moz-placeholder, .face .content .field-wrapper input[type=password]:-moz-placeholder, .face .content .field-wrapper textarea:-moz-placeholder {
  opacity: 0;
}
.face .content .field-wrapper input[type=text]:focus + label, .face .content .field-wrapper input[type=text]:not(:placeholder-shown) + label, .face .content .field-wrapper input[type=password]:focus + label, .face .content .field-wrapper input[type=password]:not(:placeholder-shown) + label, .face .content .field-wrapper textarea:focus + label, .face .content .field-wrapper textarea:not(:placeholder-shown) + label {
  top: -35%;
  color: #42509e;
}
.face .content .field-wrapper input[type=submit] {
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  width: 100%;
  background: #546FFE;
  line-height: 2em;
  color: #fff;
  border: 1px solid #546FFE;
  border-radius: 3px;
  padding: 5px;
}
.face .content .field-wrapper input[type=submit]:hover {
  opacity: 0.9;
}
.face .content .field-wrapper input[type=submit]:active {
  transform: scale(0.96);
}
.face .content .field-wrapper textarea {
  resize: none;
  line-height: 1em;
}
.face .content .field-wrapper textarea:focus + label, .face .content .field-wrapper textarea:not(:placeholder-shown) + label {
  top: -25%;
}
.face .thank-you-msg {
  position: absolute;
  width: 200px;
  height: 130px;
  text-align: center;
  font-size: 2em;
  color: #546FFE;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
}
.face .thank-you-msg:after {
  position: absolute;
  content: "";
  width: 50px;
  height: 25px;
  border: 10px solid #546FFE;
  border-right: 0;
  border-top: 0;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(0deg) scale(0);
  transform: translate(-50%, -50%) rotate(0deg) scale(0);
  -webkit-animation: success ease-in 0.15s forwards;
  animation: success ease-in 0.15s forwards;
  animation-delay: 2.5s;
}
.face-front {
  transform: rotateY(0deg) translateZ(125px);
}
.face-top {
  height: 250px;
  transform: rotateX(90deg) translateZ(125px);
}
.face-bottom {
  height: 250px;
  transform: rotateX(-90deg) translateZ(175px);
}

.nav {
  margin: 20px 0;
  padding: 0;
}
.nav li {
  display: inline-block;
  list-style-type: none;
  font-size: 1em;
  margin: 0 10px;
  color: #42509e;
  position: relative;
  cursor: pointer;
}
.nav li:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 20px;
  border-bottom: 1px solid #42509e;
  transition: all ease-in 0.25s;
}
.nav li:hover:after {
  width: 100%;
}

.psw, .signup, .singin {
  display: block;
  margin: 20px 0;
  font-size: 0.75em;
  text-align: center;
  color: #42509e;
  cursor: pointer;
}

.btn-login {
  background-color: #546FFE !important;
  width: 100% !important;
  color: white !important;
  height: 50px !important;
  font-size: 1.5rem !important;
}

small {
  font-size: 0.7em;
}

@-webkit-keyframes success {
  from {
    -webkit-transform: translate(-50%, -50%) rotate(0) scale(0);
  }
  to {
    -webkit-transform: translate(-50%, -50%) rotate(-45deg) scale(1);
  }
}
</style>
